import { Helmet } from 'react-helmet';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import individual from '../assets/img/icon/individual.png';
import enterprise from '../assets/img/icon/enterprise.png';

function Services() {
    const title = 'Subscription Options';
    const navigate = useNavigate();


    const gotoPayment = () => {
        navigate("/console/payment");
    };

    const gotoContactUs = () => {
        navigate("/contact");
    };
    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <div className="row g-4 pt-5 justify-content-center">
                <div className="col-12 col-lg-8 col-xxl-6">
                    <h3 className="fw-light lh-base text-dkGreen text-center">
                        Choose the category that best describes you so we can help you find the right subscription option.
                    </h3>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-12 mt-5">
                    <div className="row g-4 justify-content-center row-cols-1 row-cols-lg-3 mb-3 text-center">
                        <div className="col">
                            <div className="card mb-4 rounded-3 shadow-sm h-100">
                                <div className="card-body h-100 px-5 ps-5">
                                    <img className="img-fluid py-3" style={{ width: '6rem' }} src={individual} alt="Individual" />
                                    <h4>Individual Account</h4>
                                    <p>Individual Users, whether personal or business</p>
                                    <p className="text-start mb-0"><strong>Unique Features:</strong></p>
                                    <ul className="text-start text-primary mb-0">
                                        <li>$500 (One-Time) Annual Subscription Fee</li>
                                        <li>One User per Individual Account</li>
                                        <li>Encrypted Database for Vectored Data</li>
                                    </ul>
                              
                                <div className="w-100 mt-4">
                                    <p className="text-start mb-0"><strong>Functionality:</strong></p>
                                    <ul className="text-start">
                                        <li>Unlimited Projects and Unlimited Queries</li>
                                        <li>Multiple Files in a Project
                                            <ul>
                                                <li>Up to 10 files or Maximum of 20 MB for each Project</li>
                                            </ul>
                                        </li>
                                        <li>Batch Vectoring of Files to a “Project” or to “Resources”
                                            <ul>
                                                <li>Up to 5 files or Maximum of 10 MB for each Batch</li>
                                            </ul>
                                        </li>
                                        <li>History of Queries and Responses by Project</li>
                                        <li>Resources Directory for Vectored Files for Global Access</li>
                                        <li>Save Query Responses to PDF</li>
                                    </ul>
                                    <p className="text-start mb-0"><strong>Conditions:</strong></p>
                                    <ul className="text-start">
                                        <li>Subject to Privacy Policy and Terms of Services</li>
                                        <li>Automatic Annual Renewal of Subscription</li>
                                    </ul>
                                </div>
                                </div>  
                                <button className="btn btn-lg btn-primary fs-3 rounded-top-0" onClick={gotoPayment}>
                                    <div className="card-footer border-top-0 px-5">
                                        Get Started
                                    </div>
                                </button>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card mb-4 rounded-3 shadow-sm h-100">
                                <div className="card-body h-100 px-5 ps-5">
                                    <img className="img-fluid py-3" style={{ width: '6rem' }} src={enterprise} alt="Enterprise" />
                                    <h4>Enterprise Account</h4>
                                    <p>Any business enterprises</p>
                                    <p className="text-start mb-0"><strong>Unique Features:</strong></p>
                                    <ul className="text-start text-success mb-0">
                                        <li> Tailored Annual Subscription Fee (contact AccessEVA to discuss)</li>
                                        <li>Multiple Discreet Users under Enterprise Account</li>
                                        <li>Private URL for Encrypted Database for Vectored Data</li>
                                        <li>API Connection to File Management System of Enterprise Account</li>
                                        <li>IT Support for Interface and Onboarding</li>
                                        <li>Administrative Monitoring of Users and Metrics</li>
                                        <li>Option for Reconfiguration of Database Capacity and Processing Speed</li>
                                    </ul>
                                    <div className="w-100 mt-4">
                                    <p className="text-start mb-0"><strong>Functionality:</strong></p>
                                    <ul className="text-start">
                                        <li>Unlimited Projects and Unlimited Queries</li>
                                        <li>Multiple Files in a Project
                                            <ul>
                                                <li>Up to 10 files or Maximum of 20 MB for each Project</li>
                                            </ul>
                                        </li>
                                        <li>Batch Vectoring of Files to a “Project” or to “Resources”
                                            <ul>
                                                <li>Up to 5 files or Maximum of 10 MB for each Batch</li>
                                            </ul>
                                        </li>
                                        <li>History of Queries and Responses by Project</li>
                                        <li>Resources Directory for Vectored Files for Global Access</li>
                                        <li>Save Query Responses to PDF</li>
                                    </ul>
                                    <p className="text-start mb-0"><strong>Conditions:</strong></p>
                                    <ul className="text-start">
                                        <li>Subject to Privacy Policy and Terms of Services</li>
                                        <li>Automatic Annual Renewal of Subscription</li>
                                    </ul>
                                </div>

                                </div>
                                <button className="btn btn-lg btn-primary fs-3 rounded-top-0" onClick={gotoContactUs}>
                                    <div className="card-footer border-top-0 px-5">
                                        Contact Us
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
}

export default Services;
